import { GroupPermission } from "@kekkle/shared/enums/group-permission";
import type { PermissionBadge } from "@/types/ui/permission";

/**
 * Get the CSS classes for a permission badge
 */
export function getPermissionBadgeClass(
  permission: GroupPermission | undefined,
): string {
  switch (permission) {
    case GroupPermission.ADMIN:
      return "bg-green-200 text-green-600";
    case GroupPermission.ORGANISER:
      return "bg-orange-200 text-orange-600";
    case GroupPermission.MEMBER:
      return "bg-purple-200 text-purple-600";
    default:
      return "";
  }
}

/**
 * Get the i18n key for a permission badge text
 */
export function getPermissionBadgeI18nKey(
  permission: GroupPermission | undefined,
): string {
  switch (permission) {
    case GroupPermission.ADMIN:
      return "global.roles.admin";
    case GroupPermission.ORGANISER:
      return "global.roles.organiser";
    case GroupPermission.MEMBER:
      return "global.roles.member";
    default:
      return "";
  }
}

/**
 * Get both class and i18n key for a permission badge
 */
export function getPermissionBadge(
  permission: GroupPermission | undefined,
): PermissionBadge {
  return {
    class: getPermissionBadgeClass(permission),
    i18nKey: getPermissionBadgeI18nKey(permission),
  };
}
